<template>
  <div class="d-flex for-customer mx-auto" style="max-width: 1480px">
    <left-menu-for-customer class="d-none d-md-block" />
    <div class="d-flex flex-column w-100">
      <top-menu-for-customer />
      <div
        class="min-vh-100 px-3 px-md-5 py-4"
        style="background-color: var(--epi-grey)"
      >
        <div class="mb-2"></div>
        <slot></slot>
        <div class="position-relative start-0 bottom-0 mt-5">
          COPYRIGHT &copy; 2022 EPI, All Rights Reserved
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventName } from "@/const";

export default {
  name: "EpiLayoutForCustomer",
  data() {
    return {
      leftMenuForCustomerOpeningEventName:
        EventName.LeftMenuForCustomerOffcanvasOpening,
    };
  },
};
</script>

<style lang="stylus">
:root:has(.for-customer)
  --epi-primary-rgb 85, 82, 189
</style>
